<template>
	<v-card
		color="secondary"
		height="100%"
	>
		<v-container grid-list-xs 
			class="cont"
		>
			<v-layout 
				column 
				wrap 
				alig-center
				justify-center
			>
				<v-icon size="50">
					fas fa-comments
				</v-icon>
				<v-spacer />
				<h1 style="text-align: center;">
					Chat Cooming Soon
				</h1>
			</v-layout>
		</v-container>
	</v-card>
</template>

<script>
export default {
	props: [],
  
	data () {
		return {
		
		}
	}
}
</script>


<style lang="scss" scoped>
@import '@/styles/index.scss';

.cont {
	height: 100% !important; 
	display:flex; 
	align-items: center;
}

</style>